import React, { useState, useEffect } from 'react'
import { TextField } from '@mui/material'
import Button from '../../common/Button'
import useFetch from '../../hooks/useFetch'
import useAuth from '../../hooks/useAuth'
import LoadingIndicator from '../../common/LoadingIndicator'
import { urlApi } from '../../config'
import { formatPrice } from '../../utils'

const ImportCohort = () => {
  const [selectedService, setSelectedService] = useState('brevo')
  const [campaignName, setCampaignName] = useState('')
  const [cohortId, setCohortId] = useState('')
  const [scheduleDate, setScheduleDate] = useState('')
  const [scheduleTime, setScheduleTime] = useState('')
  const [shouldSchedule, setShouldSchedule] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [results, setResults] = useState([])

  const handleSubmit = () => {
    if (!campaignName || !cohortId) {
      alert('Por favor completa todos los campos')
      return
    }
    if (shouldSchedule && (!scheduleDate || !scheduleTime)) {
      alert('Por favor completa todos los campos para schedulear')
      return
    }
    setIsSubmitting(true)
  }

  const handleSuccess = data => {
    alert('Cohort importado exitosamente')
    setResults(prev => [
      {
        type: selectedService,
        cohortId,
        campaignName,
        total: data.total,
        success: data.success,
        failed: data.failed
      },
      ...prev
    ])
    setCampaignName('')
    setCohortId('')
    setIsSubmitting(false)
  }

  const handleError = () => {
    alert('Error al importar el cohort')
    setIsSubmitting(false)
  }

  return (
    <div className='flex flex-col justify-center items-center bg-white dark:bg-dk-bg h-full'>
      <div className='max-w-md mx-auto bg-white dark:bg-dk-surface rounded-lg shadow-lg p-6 w-full'>
        <div className='mb-6'>
          <label className='block text-base font-medium mb-3'>Seleccionar servicio</label>
          <div className='space-y-2'>
            <label className='flex items-center'>
              <input
                type='radio'
                name='service'
                value='brevo'
                checked={selectedService === 'brevo'}
                onChange={e => setSelectedService(e.target.value)}
                className='h-4 w-4 text-light_coral focus:ring-light_coral border-gray-300 dark:border-dk-border'
              />
              <span className='ml-2 text-base'>Brevo</span>
            </label>
            <label className='flex items-center'>
              <input
                type='radio'
                name='service'
                value='onesignal'
                checked={selectedService === 'onesignal'}
                onChange={e => setSelectedService(e.target.value)}
                className='h-4 w-4 text-light_coral focus:ring-light_coral border-gray-300 dark:border-dk-border'
              />
              <span className='ml-2 text-base'>OneSignal</span>
            </label>
            <label className='flex items-center'>
              <input
                type='radio'
                name='service'
                value='brevo_whatsapp'
                checked={selectedService === 'brevo_whatsapp'}
                onChange={e => setSelectedService(e.target.value)}
                className='h-4 w-4 text-light_coral focus:ring-light_coral border-gray-300 dark:border-dk-border'
              />
              <span className='ml-2 text-base'>Whatsapp</span>
            </label>
          </div>
        </div>

        <div className='mb-4'>
          <TextField
            label='Nombre de campaña'
            variant='outlined'
            fullWidth
            value={campaignName}
            onChange={e => setCampaignName(e.target.value)}
            placeholder='Ingresa el nombre de la campaña'
          />
        </div>

        <div className='mb-4'>
          <TextField
            label='Cohort ID'
            variant='outlined'
            fullWidth
            value={cohortId}
            onChange={e => setCohortId(e.target.value)}
            placeholder='Ingresa el Cohort ID'
          />
        </div>

        {selectedService === 'onesignal' && (
          <>
            <label className='flex items-center mb-4'>
              <input
                type='checkbox'
                checked={shouldSchedule}
                onChange={e => setShouldSchedule(e.target.checked)}
                className='h-4 w-4 text-light_coral focus:ring-light_coral border-gray-300 dark:border-dk-border rounded'
              />
              <span className='ml-2 my-2 text-base'>Programar</span>
            </label>
            {shouldSchedule && (
              <div className='mb-4 flex gap-3'>
                <TextField
                  label='Fecha'
                  type='date'
                  variant='outlined'
                  fullWidth
                  value={scheduleDate}
                  onChange={e => setScheduleDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label='Hora'
                  type='time'
                  variant='outlined'
                  fullWidth
                  value={scheduleTime}
                  onChange={e => setScheduleTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            )}
          </>
        )}

        {isSubmitting ? (
          <div className='w-full py-2'>
            {selectedService === 'onesignal' && shouldSchedule ? (
              <div className='flex justify-center'>
                <ScheduleCohortRequest
                  body={{
                    cohort_id: cohortId,
                    campaign_name: campaignName,
                    type: selectedService,
                    date: scheduleDate,
                    time: scheduleTime
                  }}
                  handleSuccess={handleSuccess}
                  handleError={handleError}
                />
              </div>
            ) : selectedService === 'onesignal' ? (
              <OneSignalImport
                body={{
                  campaign_name: campaignName,
                  cohort_id: cohortId,
                  type: selectedService
                }}
                handleSuccess={handleSuccess}
                handleError={handleError}
              />
            ) : (
              <div className='flex justify-center'>
                <ImportCohortRequest
                  body={{
                    campaign_name: campaignName,
                    cohort_id: cohortId,
                    type: selectedService
                  }}
                  handleSuccess={handleSuccess}
                  handleError={handleError}
                />
              </div>
            )}
          </div>
        ) : (
          <Button onClick={handleSubmit} className='w-full' name={shouldSchedule ? 'Schedulear' : 'Importar'} />
        )}

        {results.length > 0 && (
          <>
            {results.map(result => (
              <div className='mt-6 p-4 bg-green-50 dark:bg-emerald-500/10 border border-green-200 dark:border-dk-border rounded-lg'>
                <h3 className='text-base font-semibold text-green-800 dark:text-emerald-400 mb-3'>
                  {result.type === 'brevo'
                    ? 'Brevo'
                    : result.type === 'brevo_whatsapp'
                      ? 'Whatsapp'
                      : 'OneSignal'}
                </h3>
                <div className='space-y-2 text-sm'>
                  <div>
                    <span className='font-medium'>Campaña:</span> {result.campaignName}
                  </div>
                  <div>
                    <span className='font-medium'>Cohort ID:</span> {result.cohortId}
                  </div>
                  <div>
                    <span className='font-medium'>Total:</span> {formatPrice(result.total)}
                  </div>
                  <div>
                    <span className='font-medium'>Importados:</span> {formatPrice(result.success)}
                  </div>
                  <div>
                    <span className='font-medium'>No Importados:</span> {formatPrice(result.failed)}
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  )
}

const OneSignalImport = ({ body, handleSuccess, handleError }) => {
  const { getAccessTokenSilently } = useAuth()
  const [requests, setRequests] = useState([])
  const [done, setDone] = useState(false)

  const setStatus = (index, status, data) =>
    setRequests(prev =>
      prev.map((request, position) =>
        position === index ? { ...request, status, ...(data && { data }) } : request
      )
    )

  useEffect(() => {
    const run = async () => {
      try {
        const token = await getAccessTokenSilently()
        const headers = {
          'Content-Type': 'application/json',
          ...(typeof token === 'string' && { authorization: `Bearer ${token}` })
        }

        setRequests([{ page: 1, limit: 10000, status: 'loading' }])

        const probeResponse = await fetch(`${urlApi}/admin/broadcast/cohorts`, {
          method: 'POST',
          credentials: 'include',
          headers,
          body: JSON.stringify({ ...body, limit: 10000, page: 1 })
        })

        if (!probeResponse.ok) {
          setRequests([{ page: 1, limit: 10000, status: 'error' }])
          handleError()
          return
        }

        const probeData = await probeResponse.json()
        const { total } = probeData.pagination
        const totalPages = Math.ceil(total / 10000)
        const remainingPages = totalPages - 1

        setRequests([
          { page: 1, limit: 10000, status: 'success', data: probeData },
          ...Array.from({ length: remainingPages }, (_, index) => ({
            page: index + 2,
            limit: 10000,
            status: 'pending'
          }))
        ])

        const allResults = [probeData]

        for (let index = 0; index < remainingPages; index++) {
          const page = index + 2
          const requestIndex = index + 1
          setStatus(requestIndex, 'loading')

          try {
            const response = await fetch(`${urlApi}/admin/broadcast/cohorts`, {
              method: 'POST',
              credentials: 'include',
              headers,
              body: JSON.stringify({ ...body, limit: 10000, page })
            })

            if (!response.ok) throw new Error()
            const data = await response.json()
            setStatus(requestIndex, 'success', data)
            allResults.push(data)
          } catch {
            setStatus(requestIndex, 'error')
          }
        }

        setDone(true)
        handleSuccess({
          total: allResults.reduce((sum, result) => sum + (result.total || 0), 0),
          success: allResults.reduce((sum, result) => sum + (result.success || 0), 0),
          failed: allResults.reduce((sum, result) => sum + (result.failed || 0), 0)
        })
      } catch {
        handleError()
      }
    }

    run()
  }, [])

  return (
    <div className='w-full space-y-2'>
      {requests.map((req, i) => (
        <div
          key={i}
          className={`flex items-center justify-between px-3 py-2 rounded text-sm border ${req.status === 'success'
            ? 'bg-green-50 dark:bg-emerald-500/10 border-green-200 dark:border-dk-border'
            : req.status === 'error'
              ? 'bg-red-50 dark:bg-red-500/10 border-red-200 dark:border-dk-border'
              : req.status === 'loading'
                ? 'bg-blue-50 dark:bg-blue-500/10 border-blue-200 dark:border-dk-border'
                : 'bg-gray-50 dark:bg-dk-raised border-gray-200 dark:border-dk-border'
            }`}
        >
          <span>
            {i === 0 ? 'Inicial' : `Update ${req.page}`} (limit: {req.limit})
          </span>
          <span
            className={`font-medium ${req.status === 'success'
              ? 'text-green-600 dark:text-emerald-400'
              : req.status === 'error'
                ? 'text-red-600 dark:text-red-400'
                : req.status === 'loading'
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-400 dark:text-gray-400'
              }`}
          >
            {req.status === 'loading' && <LoadingIndicator size={16} />}
            {req.status === 'success' && 'OK'}
            {req.status === 'error' && 'Error'}
            {req.status === 'pending' && 'Pendiente'}
          </span>
        </div>
      ))}
      {done && (
        <p className='text-center text-sm text-green-700 dark:text-emerald-400 font-medium mt-2'>
          Importación completada
        </p>
      )}
    </div>
  )
}

const ScheduleCohortRequest = ({ body, handleSuccess, handleError }) => {
  const { loading, data, responseOk } = useFetch(`${urlApi}/admin/broadcast/cohorts/schedule`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        handleSuccess(data)
      } else {
        handleError()
      }
    }
  }, [loading, responseOk])

  return <LoadingIndicator size={26} />
}

const ImportCohortRequest = ({ body, handleSuccess, handleError }) => {
  const { loading, data, responseOk } = useFetch(`${urlApi}/admin/broadcast/cohorts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        handleSuccess(data)
      } else {
        handleError()
      }
    }
  }, [loading, responseOk])

  return <LoadingIndicator size={26} />
}

export default ImportCohort
